import { api } from './api';
import { UserData } from '../types';

export async function getUserProfile(): Promise<UserData> {
  const response = await api.get(`admin/me`);
  return response.json();
}
